import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import elementClosest from 'element-closest'
// import './config/arrayMap.pollyfil'

import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import App from './containers/App'
import store from './store'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'animate.css'
import 'reset-css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './style.sass'

elementClosest(window)

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,

  document.getElementById('root')
)

serviceWorker.register()
